import Billing from "services/billingApi";
import type { PaymentMethodsProps } from "store/modules/DealerCare/types.store";
import { PAYMENT_METHOD_ORDER } from "../constants/paymentMethods";
import { sanitizePaymentMethodsBrands } from "./sanitizePaymentMethods";
import { parsePaymentMethodsFromBillingResponse } from "./parsePaymentMethodsFromBilling";

function hasOnDeliveryAndInAppPair(list: PaymentMethodsProps[]): boolean {
  const hasOnDelivery = list.some(
    (pm) =>
      pm.order === PAYMENT_METHOD_ORDER.DELIVERY ||
      pm.description === "ONDELIVERY",
  );
  const hasInApp = list.some(
    (pm) =>
      pm.order === PAYMENT_METHOD_ORDER.ONLINE || pm.description === "INAPP",
  );
  return hasOnDelivery && hasInApp;
}

export async function resolvePaymentMethodsForBillingSave(
  dealerId: string,
  paymentMethodsFromApi: PaymentMethodsProps[] | null | undefined,
): Promise<PaymentMethodsProps[] | null> {
  const fromProps = Array.isArray(paymentMethodsFromApi)
    ? sanitizePaymentMethodsBrands(paymentMethodsFromApi)
    : [];
  if (hasOnDeliveryAndInAppPair(fromProps)) {
    return fromProps;
  }
  try {
    const res = await Billing.get(
      `/v2/dealers/${dealerId}/paymentmethods-all-origins`,
    );
    const parsed = sanitizePaymentMethodsBrands(
      parsePaymentMethodsFromBillingResponse(res.data),
    );
    if (!hasOnDeliveryAndInAppPair(parsed)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}
